function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Iframe = /*#__PURE__*/function () {
  function Iframe() {
    _classCallCheck(this, Iframe);
  }

  _createClass(Iframe, [{
    key: "make",

    /**
     * Appends the iframe with the given url to the document's body.
     * If classNames.container specified, wraps iframe in div container and appends the
     * container to body.
     *
     * @param {String} url - The cosmic cube url to open.
     * @param {HTMLElement} [parentEl = document.body] element to append the iframe to
     */
    value: function make(_ref) {
      var src = _ref.src,
          parentEl = _ref.parentEl,
          onMessage = _ref.onMessage,
          onLoad = _ref.onLoad,
          onError = _ref.onError,
          id = _ref.id;
      this._isAlive = true;
      this._onMessage = onMessage;
      this._parentElement = parentEl || document.body;
      this._requester = document.createElement('iframe');

      this._requester.setAttribute('frameborder', 0);

      this._requester.setAttribute('id', id);

      this._requester.setAttribute('sandbox', 'allow-scripts allow-same-origin');

      this._requester.setAttribute('width', '100%');

      this._requester.setAttribute('height', '100%');

      this._requester.onload = onLoad;
      this._requester.onError = onError;
      window.addEventListener('message', this._onMessage); // This is required to bust the iframe cache in the case where
      // the user navigates to a different site and then hits the 'back' button
      // @see http://stackoverflow.com/questions/2648053/preventing-iframe-caching-in-browser

      this._requester.setAttribute('name', Date.now());

      this._parentElement.appendChild(this._requester); // Set the `src` after appending the iframe to the parent document.
      // Otherwise, IE will throw a "Permission Denied" error.


      this._requester.src = src;
    }
    /**
     * Removes the iframe / iframe container from body.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (!this._isAlive) return;
      window.removeEventListener('message', this._onMessage);

      this._parentElement.removeChild(this._requester);

      this._parentElement = null;
      this._requester = null;
      this._isAlive = false;
    }
  }]);

  return Iframe;
}();

export default Iframe;